var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M6.08025 15.8203L12.3103 15.8203L17.9203 15.8203C18.8803 15.8203 19.3603 14.6603 18.6803 13.9803L13.5003 8.80031C12.6703 7.97031 11.3203 7.97031 10.4903 8.80031L8.52025 10.7703L5.31025 13.9803C4.64025 14.6603 5.12025 15.8203 6.08025 15.8203Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }